export const environment = {
  production: true,
  mock: false,
  buildNumber: '20261102.2',
  appInsights: {
    instrumentationKey: '61e1a7fb-8428-43b0-a2a1-7e2a5eb13c3b',
  },
  baseUrl: 'https://checkin.devcloud.cae.com',
  azureAd: {
    tenant: '006c1e48-e342-47e9-ab5d-0dd9ff89bd96',
    clientId: '4f44bea3-9851-4215-8753-725a944df04b',
    redirectPath: 'login',
    scopes: ['api://4f44bea3-9851-4215-8753-725a944df04b/Global.All'],
    loginUrl: null,
  },
  launchDarkly: {
    isEnabled: true,
    apiKey: '5cd15d2c6ebc550823318d47',
  },
  store: {
    featureFlagsEnabled: true,
  },
  api: {
    baseUrl: 'https://api.devcloud.cae.com/training/checkinkioskwebapi/v1',
  },
  heap: {
    apiKey: '3746394984',
  },
  idleTime: 60,
  idleTimeout: 30,
  refreshTimer: '30000',
  byPassCode: 'H3C0T9',
  documentScanner: {
    apidId: 'checkin',
    apiKey: 'checkin',
  },
};
